var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bl-button-av',{on:{"click":_vm.gotoLoginPage}},[_vm._v("\n  Daftar jadi investor\n")])}
var staticRenderFns = []

export { render, staticRenderFns }